(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afr-collection-intro"] && !Shopify.designMode) return;
  try {
    
  const afrOudFloats = document.querySelectorAll('[data-afr-oud-float]');
  if ('IntersectionObserver' in window) {
    const afrOudObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.dataset.afrInView = String(entry.isIntersecting);
        entry.target.style.animationPlayState = entry.isIntersecting && !document.hidden ? 'running' : 'paused';
      });
    }, { threshold: 0.15 });
    afrOudFloats.forEach(element => afrOudObserver.observe(element));
    document.addEventListener('visibilitychange', () => {
      afrOudFloats.forEach(element => {
        element.style.animationPlayState = element.dataset.afrInView === 'true' && !document.hidden ? 'running' : 'paused';
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afr-gallery"] && !Shopify.designMode) return;
  try {
    
function initAfrGalleries() {
  document.querySelectorAll('[data-afr-gallery]').forEach(function (gallery) {
    if (gallery.dataset.afrReady) return;
    const controls = gallery.querySelector('[data-afr-controls]');
    if (!controls) return;
    const buttons = Array.from(controls.querySelectorAll('[data-afr-tab]'));
    const panels = Array.from(gallery.querySelectorAll('[data-afr-panel]'));
    if (buttons.length !== panels.length || buttons.length < 2) return;
    function select(index) {
      buttons.forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === index)); });
      panels.forEach(function (panel, i) { panel.hidden = i !== index; });
    }
    buttons.forEach(function (button, index) { button.addEventListener('click', function () { select(index); }); });
    gallery.querySelectorAll('[data-afr-fallback]').forEach(function (heading) { heading.hidden = true; });
    controls.hidden = false;
    select(0);
    gallery.dataset.afrReady = 'true';
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAfrGalleries);
else initAfrGalleries();
document.addEventListener('shopify:section:load', initAfrGalleries);

const afrOfferInstances = new Map();
function initAfrOfferCarousels() {
  document.querySelectorAll('[data-afr-offer-carousel]').forEach(function (gallery) {
    if (afrOfferInstances.has(gallery)) return;
    const viewport = gallery.querySelector('[data-afr-offer-viewport]');
    const track = viewport && viewport.querySelector('.afr-product-grid');
    if (!track || track.children.length < 2) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 768px)');
    let frame = 0;
    let lastTime = 0;
    let step = 0;
    let sign = 1;
    let visible = false;
    let pressed = false;
    let hovered = false;
    let keyboardFocus = false;
    let pointerInput = false;
    let releaseTimer = 0;
    function measure() {
      const first = track.firstElementChild;
      step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      sign = getComputedStyle(viewport).direction === 'rtl' ? -1 : 1;
    }
    function canRun() {
      return gallery.isConnected && desktop.matches && visible && !pressed && !keyboardFocus && !document.hidden && !reduced.matches && step > 0 && track.children.length * step > viewport.clientWidth + step;
    }
    function stop() {
      cancelAnimationFrame(frame);
      frame = 0;
      lastTime = 0;
    }
    function tick(time) {
      frame = 0;
      if (!canRun()) { lastTime = 0; return; }
      const elapsed = lastTime ? Math.min(time - lastTime, 64) : 0;
      lastTime = time;
      let offset = Math.max(0, sign * viewport.scrollLeft) + step * elapsed / (hovered ? 10000 : 8000);
      while (offset >= step) {
        track.appendChild(track.firstElementChild);
        offset -= step;
      }
      viewport.scrollLeft = sign * offset;
      frame = requestAnimationFrame(tick);
    }
    function start() {
      if (!frame && canRun()) { lastTime = 0; frame = requestAnimationFrame(tick); }
    }
    function pause() { pressed = true; stop(); }
    function resume() { pressed = false; start(); }
    function release(event) {
      if (event.pointerType !== 'mouse') {
        clearTimeout(releaseTimer);
        releaseTimer = setTimeout(resume, 350);
      }
    }
    viewport.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') hovered = true;
    }, options);
    viewport.addEventListener('pointerdown', function () {
      pointerInput = true;
      keyboardFocus = false;
      clearTimeout(releaseTimer);
      pause();
    }, options);
    viewport.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') { hovered = false; resume(); }
    }, options);
    window.addEventListener('pointerup', release, options);
    window.addEventListener('pointercancel', release, options);
    viewport.addEventListener('wheel', function () {
      pause();
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(resume, 1200);
    }, { passive: true, signal: controller.signal });
    document.addEventListener('keydown', function () { pointerInput = false; }, options);
    viewport.addEventListener('focusin', function () {
      if (!pointerInput) { keyboardFocus = true; stop(); }
    }, options);
    viewport.addEventListener('focusout', function () {
      queueMicrotask(function () {
        keyboardFocus = !pointerInput && viewport.contains(document.activeElement);
        if (!keyboardFocus) start();
      });
    }, options);
    viewport.addEventListener('keydown', function () { keyboardFocus = true; stop(); }, options);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); }, options);
    reduced.addEventListener('change', function () { if (reduced.matches) stop(); else start(); }, options);
    desktop.addEventListener('change', function () { if (desktop.matches) start(); else stop(); }, options);
    const sectionObserver = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start(); else stop();
    }, { threshold: 0.05 });
    sectionObserver.observe(viewport);
    const cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.contains(document.activeElement)) return;
        entry.target.inert = !entry.isIntersecting;
        if (entry.isIntersecting) entry.target.removeAttribute('aria-hidden');
        else entry.target.setAttribute('aria-hidden', 'true');
      });
    }, { root: viewport, threshold: 0 });
    Array.from(track.children).forEach(function (cell) { cardObserver.observe(cell); });
    const resizeObserver = new ResizeObserver(function () { measure(); start(); });
    resizeObserver.observe(viewport);
    measure();
    afrOfferInstances.set(gallery, function () {
      stop();
      clearTimeout(releaseTimer);
      controller.abort();
      sectionObserver.disconnect();
      cardObserver.disconnect();
      resizeObserver.disconnect();
      Array.from(track.children).forEach(function (cell) { cell.inert = false; cell.removeAttribute('aria-hidden'); });
      afrOfferInstances.delete(gallery);
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAfrOfferCarousels);
else initAfrOfferCarousels();
document.addEventListener('shopify:section:load', initAfrOfferCarousels);
document.addEventListener('shopify:section:unload', function (event) {
  afrOfferInstances.forEach(function (dispose, gallery) {
    if (event.target.contains(gallery)) dispose();
  });
});


  } catch(e) { console.error(e); }
})();
})();
